import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import SidebarTrigger from '@/components/header/SidebarTrigger';
import {
  Sidebar,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
  useSidebar
} from '@/components/ui/sidebar';

import buducloudLogo from '@/assets/buducloud-logo.png';
import signalsLogo from '@/assets/signals-logo.png';

import NewChatButton from '../header/NewChat';
import { ThreadHistory } from './ThreadHistory';

/**
 * The product mark at the top, the company mark at the bottom.
 *
 * Both are the logos the customer knows. The Chainlit fork's own pink flower in
 * `assets/logo_*.svg` is not the Signals brand and is deliberately not used
 * here; `Logo.tsx` still resolves the server logo endpoint, which a tenant can
 * point at its own file.
 *
 * These two are PNG and will soften on a retina display — worth replacing with
 * vector before this ships to a customer.
 */
export default function LeftSidebar({
  ...props
}: React.ComponentProps<typeof Sidebar>) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isMobile, setOpenMobile } = useSidebar();

  useEffect(() => {
    if (isMobile) setOpenMobile(false);
  }, [pathname]);

  return (
    <Sidebar {...props} className="border-none">
      <SidebarHeader className="py-3">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-1.5 min-w-0">
            <SidebarTrigger />
            <img
              src={signalsLogo}
              alt="Signals"
              className="h-[15px] w-auto block shrink-0"
            />
          </div>
          <div className="flex items-center">
            <NewChatButton navigate={navigate} />
          </div>
        </div>
      </SidebarHeader>
      <ThreadHistory />
      <SidebarFooter
        className="px-3.5 py-3"
        style={{ borderTop: '1px solid var(--sig-border-light)' }}
      >
        <div className="flex items-center justify-between gap-2">
          <img
            src={buducloudLogo}
            alt="BuduCloud"
            className="h-[17px] w-auto block"
            style={{ opacity: 0.85 }}
          />
        </div>
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
